import { render } from "./FillBlankTextExerciseComponent.vue?vue&type=template&id=29f00a5a&scoped=true"
import script from "./FillBlankTextExerciseComponent.vue?vue&type=script&lang=js"
export * from "./FillBlankTextExerciseComponent.vue?vue&type=script&lang=js"

import "./FillBlankTextExerciseComponent.vue?vue&type=style&index=0&id=29f00a5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f00a5a"]])

export default __exports__